import { useState } from 'react';
import Aside from './aside';
import './layout.css';
import Topbar from './topbar';

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <div className="layout">
      <a className="skip_link" href="#main-content">Skip to main content</a>

      <Aside isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <div className="main">
        <Topbar toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
        <main className="content" id="main-content" tabIndex={-1}>
          {children}
        </main>
      </div>

    </div>
  );
}

export default Layout;